<template>
    <div>
        <!-- 添加加载状态和错误提示 -->
        <div v-if="loading" class="loading">加载中...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <scheduled-tasks-form v-if="!loading && !error && Object.keys(privData).length > 0" :privData="privData"
            @submit="submitForm" />
    </div>
</template>

<script>
import axios from 'axios';
import ScheduledTasksForm from './scheduledTasksForm.vue';
const DATA_MAPS = {
    enabled: { '1': '是', '0': '否' },
    trigger: { '1': '单次', '2': '每日', '3': '每周', '4': '每月' },
    week: {
        '1': '星期一', '2': '星期二', '3': '星期三',
        '4': '星期四', '5': '星期五', '6': '星期六', '7': '星期日'
    },
    time: {
        '20': '20:00', '21': '21:00', '22': '22:00', '24': '24:00',
        '1': '01:00', '2': '02:00', '3': '03:00', '4': '04:00',
        '5': '05:00', '6': '06:00', '7': '07:00', '8': '08:00'
    },
    notificationMethod: { '1': '邮件' }
};
export default {
    components: { ScheduledTasksForm },
    data() {
        return {
            loading: false,
            error: null,
            formData: {},
            privData: {}
        };
    },
    created() {
        this.fetchTaskData();
    },
    methods: {
        async submitForm(e) {
            try {
                const obj = {
                    id: e.id,
                    name: e.task,
                    description: e.taskDescription,
                    type: e.executeCycle,
                    executionTime: e.executeTime,
                    weekDay: e.executionWeek,
                    noticeType: e.notificationMethod,
                    enabled: e.isEnabled,
                    recipient: e.recipient,
                    ccUser: e.cc
                };
                const convertedData = this.reverseMapValues(obj, DATA_MAPS);
                const { data } = await axios.post("pmdm/clockTask/updateClockTask", convertedData);
                if (data.code === 200) {
                    this.$message.success(data.message || '操作成功');
                    this.$emit('setRefresh', obj);
                } else {
                    this.$message.error(data.message || '操作失败，请重试');
                }
            } catch (error) {
                console.error('请求失败:', error);
            }
        },
        async fetchTaskData() {
            try {
                this.loading = true;
                this.error = null;
                const taskId = this.$route.query.id;
                if (!taskId) {
                    return
                }
                const { data } = await axios.get(`pmdm/clockTask/queryTaskById?id=${taskId}`);
                const clockTask = data.object?.clockTask;
                if (!clockTask) {
                    return
                }
                this.formData = this.processTaskData(clockTask);
                this.privData = { ...this.formData };
            } catch (err) {
                this.handleError(err);
            } finally {
                this.loading = false;
            }
        },
        processTaskData(task) {
            const safeMap = (value, map) => map[value] ?? '';
            return {
                id: task.id,
                task: task.name || '',
                taskDescription: task.description || '',
                executeCycle: safeMap(task.type, DATA_MAPS.trigger),
                executionWeek: safeMap(task.weekDay, DATA_MAPS.week),
                // executeTime: task.executionTime || '',
                executeTime: safeMap(task.executionTime, DATA_MAPS.time),
                notificationMethod: safeMap(task.noticeType, DATA_MAPS.notificationMethod),
                isEnabled: safeMap(String(task.enabled), DATA_MAPS.enabled),
                recipient: task.recipient || '',
                cc: task.ccUser || ''
            };
        },
        reverseMapValues(data, maps) {
            const keyMapping = {
                enabled: 'enabled',
                type: 'trigger',
                executionTime: 'time',
                weekDay: 'week',
                noticeType: 'notificationMethod'
            };

            return Object.fromEntries(
                Object.entries(data).map(([key, value]) => {
                    const mapKey = keyMapping[key];
                    return [
                        key,
                        mapKey ? this.reverseMap(value, maps[mapKey]) : value
                    ];
                })
            );
        },

        reverseMap(value, map) {
            // 创建反向映射缓存
            if (!this._reverseMapCache) {
                this._reverseMapCache = new Map();
            }
            if (!this._reverseMapCache.has(map)) {
                this._reverseMapCache.set(map, Object.fromEntries(
                    Object.entries(map).map(([k, v]) => [v, k])
                ));
            }
            return this._reverseMapCache.get(map)[value] ?? value;
        },
        handleError(error) {
            this.error = error.message || '数据加载失败，请稍后重试';
            console.error('任务加载异常:', error);
        }
    }
};
</script>

<style scoped>
.loading {
    padding: 20px;
    text-align: center;
    color: #666;
}

.error {
    padding: 20px;
    color: #ff4d4f;
    border: 1px solid #ffa39e;
    background: #fff1f0;
    border-radius: 4px;
}
</style>